import React from 'react';
import '../styles/loader.css';

export default function Loader({ size = 'medium', text = '' }) {
  return (
    <div className={`loader-wrapper loader-${size}`}>
      <div className="loader-spinner"></div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
}
